/**
 * Order Service
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpResponse,
  HttpEvent,
  HttpContext,
} from '@angular/common/http';
import { Observable } from 'rxjs';

// @ts-ignore
import { ModApprovalTimeoutConfigDTO } from '../model/modApprovalTimeoutConfigDTO';
// @ts-ignore
import { ModApprovalTimeoutConfigVO } from '../model/modApprovalTimeoutConfigVO';
// @ts-ignore
import { ModApprovalThresholdConfigDTO } from '../model/modApprovalThresholdConfigDTO';
// @ts-ignore
import { ModApprovalThresholdConfigVO } from '../model/modApprovalThresholdConfigVO';
// @ts-ignore
import { ModificationDecisionDTO } from '../model/modificationDecisionDTO';
// @ts-ignore
import { OrderBaseDTO } from '../model/orderBaseDTO';
// @ts-ignore
import { OrderBaseEditResultVO } from '../model/orderBaseEditResultVO';
// @ts-ignore
import { OrderModificationRequestVO } from '../model/orderModificationRequestVO';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';

@Injectable({
  providedIn: 'root',
})
export class OrderModificationApprovalControllerService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: Configuration,
  ) {
    super(basePath, configuration);
  }

  /**
   * Submit order base edit (apply or create pending approval)
   */
  public submitOrderBaseEdit(
    orderBaseDTO: OrderBaseDTO,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<OrderBaseEditResultVO>;
  public submitOrderBaseEdit(
    orderBaseDTO: OrderBaseDTO,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<OrderBaseEditResultVO>>;
  public submitOrderBaseEdit(
    orderBaseDTO: OrderBaseDTO,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<OrderBaseEditResultVO>>;
  public submitOrderBaseEdit(
    orderBaseDTO: OrderBaseDTO,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    if (orderBaseDTO === null || orderBaseDTO === undefined) {
      throw new Error(
        'Required parameter orderBaseDTO was null or undefined when calling submitOrderBaseEdit.',
      );
    }

    let localVarHeaders = this.defaultHeaders;
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'BearerAuthentication',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['*/*']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected,
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();
    const localVarTransferCache: boolean = options?.transferCache ?? true;

    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Content-Type',
        httpContentTypeSelected,
      );
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/order/order-base`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<OrderBaseEditResultVO>(
      'put',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: orderBaseDTO,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get pending modification request for an order
   */
  public getPending(
    orderId: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<OrderModificationRequestVO>;
  public getPending(
    orderId: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<OrderModificationRequestVO>>;
  public getPending(
    orderId: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<OrderModificationRequestVO>>;
  public getPending(
    orderId: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    if (orderId === null || orderId === undefined) {
      throw new Error(
        'Required parameter orderId was null or undefined when calling getPending.',
      );
    }

    let localVarHeaders = this.defaultHeaders;
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'BearerAuthentication',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['*/*']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected,
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();
    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/order/modification-requests/pending/${this.configuration.encodeParam({ name: 'orderId', value: orderId, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int64' })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<OrderModificationRequestVO>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Approve pending modification at acting level (1/2/3)
   */
  public approve(
    id: number,
    level: number,
    modificationDecisionDTO?: ModificationDecisionDTO,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<OrderModificationRequestVO>;
  public approve(
    id: number,
    level: number,
    modificationDecisionDTO?: ModificationDecisionDTO,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<OrderModificationRequestVO>>;
  public approve(
    id: number,
    level: number,
    modificationDecisionDTO?: ModificationDecisionDTO,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<OrderModificationRequestVO>>;
  public approve(
    id: number,
    level: number,
    modificationDecisionDTO?: ModificationDecisionDTO,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling approve.',
      );
    }
    if (level === null || level === undefined) {
      throw new Error(
        'Required parameter level was null or undefined when calling approve.',
      );
    }

    let localVarHeaders = this.defaultHeaders;
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'BearerAuthentication',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['*/*']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected,
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();
    const localVarTransferCache: boolean = options?.transferCache ?? true;

    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Content-Type',
        httpContentTypeSelected,
      );
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/order/modification-requests/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int64' })}/approve/${this.configuration.encodeParam({ name: 'level', value: level, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int32' })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<OrderModificationRequestVO>(
      'post',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: modificationDecisionDTO,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Reject pending modification request
   */
  public reject(
    id: number,
    modificationDecisionDTO?: ModificationDecisionDTO,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<OrderModificationRequestVO>;
  public reject(
    id: number,
    modificationDecisionDTO?: ModificationDecisionDTO,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<OrderModificationRequestVO>>;
  public reject(
    id: number,
    modificationDecisionDTO?: ModificationDecisionDTO,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<OrderModificationRequestVO>>;
  public reject(
    id: number,
    modificationDecisionDTO?: ModificationDecisionDTO,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling reject.',
      );
    }

    let localVarHeaders = this.defaultHeaders;
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'BearerAuthentication',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['*/*']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected,
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();
    const localVarTransferCache: boolean = options?.transferCache ?? true;

    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Content-Type',
        httpContentTypeSelected,
      );
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/order/modification-requests/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int64' })}/reject`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<OrderModificationRequestVO>(
      'post',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: modificationDecisionDTO,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get modification approval timeout config
   */
  public getTimeoutConfig(
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<ModApprovalTimeoutConfigVO>;
  public getTimeoutConfig(
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<ModApprovalTimeoutConfigVO>>;
  public getTimeoutConfig(
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<ModApprovalTimeoutConfigVO>>;
  public getTimeoutConfig(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'BearerAuthentication',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['*/*']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected,
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();
    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/order/modification-approval-timeout`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<ModApprovalTimeoutConfigVO>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Upsert modification approval timeout config
   */
  public upsertTimeoutConfig(
    modApprovalTimeoutConfigDTO: ModApprovalTimeoutConfigDTO,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<ModApprovalTimeoutConfigVO>;
  public upsertTimeoutConfig(
    modApprovalTimeoutConfigDTO: ModApprovalTimeoutConfigDTO,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<ModApprovalTimeoutConfigVO>>;
  public upsertTimeoutConfig(
    modApprovalTimeoutConfigDTO: ModApprovalTimeoutConfigDTO,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<ModApprovalTimeoutConfigVO>>;
  public upsertTimeoutConfig(
    modApprovalTimeoutConfigDTO: ModApprovalTimeoutConfigDTO,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    if (
      modApprovalTimeoutConfigDTO === null ||
      modApprovalTimeoutConfigDTO === undefined
    ) {
      throw new Error(
        'Required parameter modApprovalTimeoutConfigDTO was null or undefined when calling upsertTimeoutConfig.',
      );
    }

    let localVarHeaders = this.defaultHeaders;
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'BearerAuthentication',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['*/*']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected,
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();
    const localVarTransferCache: boolean = options?.transferCache ?? true;

    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Content-Type',
        httpContentTypeSelected,
      );
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/order/modification-approval-timeout`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<ModApprovalTimeoutConfigVO>(
      'put',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: modApprovalTimeoutConfigDTO,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get modification approval threshold config
   */
  public getThresholdConfig(
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<ModApprovalThresholdConfigVO>;
  public getThresholdConfig(
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<ModApprovalThresholdConfigVO>>;
  public getThresholdConfig(
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<ModApprovalThresholdConfigVO>>;
  public getThresholdConfig(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'BearerAuthentication',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['*/*']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected,
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();
    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/order/modification-approval-threshold`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<ModApprovalThresholdConfigVO>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Upsert modification approval threshold config
   */
  public upsertThresholdConfig(
    modApprovalThresholdConfigDTO: ModApprovalThresholdConfigDTO,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<ModApprovalThresholdConfigVO>;
  public upsertThresholdConfig(
    modApprovalThresholdConfigDTO: ModApprovalThresholdConfigDTO,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<ModApprovalThresholdConfigVO>>;
  public upsertThresholdConfig(
    modApprovalThresholdConfigDTO: ModApprovalThresholdConfigDTO,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<ModApprovalThresholdConfigVO>>;
  public upsertThresholdConfig(
    modApprovalThresholdConfigDTO: ModApprovalThresholdConfigDTO,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    if (
      modApprovalThresholdConfigDTO === null ||
      modApprovalThresholdConfigDTO === undefined
    ) {
      throw new Error(
        'Required parameter modApprovalThresholdConfigDTO was null or undefined when calling upsertThresholdConfig.',
      );
    }

    let localVarHeaders = this.defaultHeaders;
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'BearerAuthentication',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['*/*']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected,
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();
    const localVarTransferCache: boolean = options?.transferCache ?? true;

    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Content-Type',
        httpContentTypeSelected,
      );
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/order/modification-approval-threshold`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<ModApprovalThresholdConfigVO>(
      'put',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: modApprovalThresholdConfigDTO,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      },
    );
  }
}
